import cookies, { cookieDomain, cookiePath } from '../../../kodyl/cookies';
import { localStorage } from '../../../kodyl/web-storage';

export const LS_KEY_TOKEN = 'lltoken';

function cookieSafeKey(key) {
  return key.replace(/\//g, '_').replace('___', '__');
}

function clearCookie(key) {
  if (cookies.hasItem(cookieSafeKey(key))) {
    cookies.removeItem(cookieSafeKey(key), cookiePath, cookieDomain);
  }
}

function clearLS(key) {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
  }
}

function clear(key) {
  clearLS(key);
  clearCookie(key);
}

if (__CLIENT__) {
  try {
    // Persisted user token, automatic login
    if (cookies.hasItem(LS_KEY_TOKEN)) {
      localStorage.setItem(
        LS_KEY_TOKEN,
        JSON.parse(cookies.getItem(LS_KEY_TOKEN))
      );
      clearCookie(LS_KEY_TOKEN);
    }
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
  }
}

export function persistToken(payload) {
  if (__CLIENT__) {
    if (payload === null) {
      return clear(LS_KEY_TOKEN);
    }

    cookies.setItem(
      LS_KEY_TOKEN,
      JSON.stringify(payload),
      60 * 60,
      cookiePath,
      cookieDomain
    );
    localStorage.setItem(LS_KEY_TOKEN, payload);
  }
}
